import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

// --------------------- Types ---------------------
type User = {
  role: string;
  fullName?: string;
  profileImg?: string;
  rating?: number;
  review?: string;
};

type UserContextType = {
  user: User;
  setUser: React.Dispatch<React.SetStateAction<User>>;
  hasNewNotifications: boolean;
  setHasNewNotifications: React.Dispatch<React.SetStateAction<boolean>>;
};

// --------------------- Context ---------------------
const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

// --------------------- Provider ---------------------
export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User>({ role: "" });
  const [hasNewNotifications, setHasNewNotifications] = useState(false);
  const navigate = useNavigate();

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        hasNewNotifications,
        setHasNewNotifications,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
